import CryptoJS from "crypto-js";

const encryptData = (value, type) => {
    let Key = process.env.REACT_APP_ENC_KEY || 'hrpay-commercial-legal-system-09-2025';
    let data
    if (type === "enc") {
        data = value
        let cryptedData = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), Key).toString()
        return cryptedData;
    }
    if (type === "dec") {
        data = value
        let bytes = CryptoJS.AES.decrypt(data, Key);
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}

class CryptoUtils {
  async encrypt(text) {
    if (!text) return text;
    return encryptData(text, "enc");
  }

  async decrypt(text) {
    if (!text) return text;
    return encryptData(text, "dec");
  }
}

export { CryptoUtils };
export default encryptData;